import "semantic-ui-css/semantic.min.css";
import "./index.css";
import ReactDOM from "react-dom";
import React from "react";
import { Provider } from "react-redux";
import { ConnectedRouter } from "react-router-redux";
import { createBrowserHistory } from "history";
import { PersistGate } from "redux-persist/integration/react";
import { QueryClient, QueryClientProvider } from "react-query";
import { useGlobalFeaturesStore } from "./store/GlobalFeaturesStore";

const queryClient = new QueryClient();

// get global feature flag
const globalFeaturesStore = useGlobalFeaturesStore.getState();
globalFeaturesStore.getGlobalFeatureFlags().then(() => {
  import("./store/configureStore").then(({ default: ConfigureStore }) => {
    import("./App").then(({ default: App }) => {
      const baseUrl =
        document.getElementsByTagName("base")[0]?.getAttribute("href") || "/";
      const history = createBrowserHistory({ basename: baseUrl });
      const initialState = window.initialReduxState;
      const { store, persistor } = ConfigureStore(history, initialState);
      const rootElement = document.getElementById("root");

      ReactDOM.render(
        <Provider store={store}>
          <ConnectedRouter history={history}>
            <PersistGate loading={null} persistor={persistor}>
              <QueryClientProvider client={queryClient}>
                <App />
              </QueryClientProvider>
            </PersistGate>
          </ConnectedRouter>
        </Provider>,
        rootElement
      );
    });
  });
});
